export default __webpack_public_path__ + "static/media/Ring-in-the.4123b97d.png";